export default () => ({
  prodHandle: null,

  setButton(obj) {
    if(obj.handle == this.prodHandle) {
      document.getElementById('active-wishlist-count-nav').innerHTML = obj.amount - 1;
      if(this.$refs.button.classList.contains('active')) {
        this.$refs.button.classList.remove('active');
      }
    }
  }
});
